import { type ReactElement } from 'react';

interface EmbeddedVideoProps {
    src: string;
    title?: string;
}

function EmbeddedVideo({ src, title }: EmbeddedVideoProps): ReactElement {
    return (
        <figure className="ratio ratio-16x9">
            <iframe src={src} title={`Inbäddad video: ${title}`} allowFullScreen={true} referrerPolicy="no-referrer-when-downgrade" />
        </figure>
    );
}

export { EmbeddedVideo };
